import { getInstance } from "./index";
import axios from "axios";

export function authGuard(to, _from, next) {
  const authService = getInstance();
  // console.log(authService);
  // console.log(to);
  // console.log(_from);

  const fn = async () => {
    // pricing page is unique compared to the other pages - users can visit this page whether they are authenticated or not. 
    // If they haven't been authenticated yet, then they can visit the page normally. If they have been authenticated, then we 
    // should see if they have been onboarded or not
    if (to.name === 'pricing' && !authService.isAuthenticated) {
      return next();
    }
    
    // Check if the user is authenticated, if they are, then they may need to onboard first - in this case, they will be
    // redirected to an onboarding page. If they have already onboarded before, then proceed normally
    if (authService.isAuthenticated) {
      const auth0UserId = authService.user.sub.replace(/\|/g, '_');
      const username = authService.user.nickname;
      const emailAddress = authService.user.email;
      const idToken = await authService.getTokenSilently();

      const userResponse = await axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/getuser`, {
        auth0UserId
      }, {
        headers: {
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${idToken}`
        }
      });

      const user = userResponse.data.user;
      if (Object.keys(user).length === 0 || !user.username || !user.emailAddress) {
        await axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/ensureuser`, {
          auth0UserId,
          username,
          emailAddress
        }, {
          headers: {
            'Content-Type': 'application/json', 
            'Authorization': `Bearer ${idToken}`
          }
        });
        console.log('1: User has not yet onboarded, so redirecting to onboarding page');
        return next({ name: 'onboarding', params: { exitRoutePath: to.fullPath }});
      }

      if (to.name !== 'onboarding' && !user.hasCompletedOnboarding) {
        // If user has not yet onboarded, redirect them to onboarding page
        console.log('2: User has not yet onboarded, so redirecting to onboarding page');
        return next({ name: 'onboarding', params: { exitRoutePath: to.fullPath }});
      }

      if (to.name === 'onboarding' && user.hasCompletedOnboarding) {
        // Only allow access to onboarding page if the user has not already onboarded - redirect to the home page
        console.log('User has already onboarded, so redirecting to play page');
        return next({ name: 'home' });
      }

      return next();
    }

    // Otherwise, log in
    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn();
  }

  // Watch for the loading property to change before we check isAuthenticated
  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }
  });
}
